export default __webpack_public_path__ + "static/media/d2d.85f1fa62.jpg";